import { API_URL } from "api/API";
import getForecastInfoApi from "api/forecast/getForecastInfoApi";
import Header from "components/forecast/Header";
import ObsInfo from "components/forecast/ObsInfo";
import useRunObsDatetime from "libs/hook/useRunObsDatetime";
import useRunServerTime from "libs/hook/useRunServerTime";
import { Helmet } from "react-helmet-async";
import { useQuery } from "react-query";
import styled from "styled-components";

const Container = styled.div`
  min-height: 100vh;
  background-color: #ffffff;
  font-family: 'Montserrat', sans-serif;
`;

const Main = styled.div`
  padding: 0 20px;
`;

const Forecast = () => {
  useRunObsDatetime();

  const {data} = useQuery([API_URL.FORECAST.GET_OBS_INFO], getForecastInfoApi, {
    refetchInterval: 1000 * 10,
    refetchIntervalInBackground: true,
    refetchOnWindowFocus: false,
  });
  const obsData = data?.result ? data.data : [];

  return <Container>
    <Helmet title="OWL-Net Forecasts" />
    <Header />
    <Main>
      {obsData.map((obsInfo) => <ObsInfo key={`${obsInfo.country}`} {...obsInfo}></ObsInfo>)}
    </Main>
  </Container>
}

export default Forecast;